export default "__VITE_ASSET__9482414a__"